import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, Typography } from '@mui/material';
import DescribedField from '../DescribedField';

/**
 * TeamBlockEditor — Editor do bloco Equipe (só company)
 *
 * A página NÃO guarda mais cópia de profissional. Ela exibe automaticamente todos os profissionais
 * ativos do cadastro, com nome, foto e função lidos ao vivo do catálogo no render.
 *
 * Por que a seleção e o campo "Função na equipe" saíram: o bloco guardava uma cópia congelada na
 * publicação, que nada atualizava — em produção (01/09/2026) havia 10 profissionais já excluídos
 * ainda exibidos e 6 com nome trocado. E a cópia carregava quatro campos dos quais TRÊS estavam
 * vazios em 100% dos 207 membros publicados (`role`, `specialty`, `imageUrl`): o bloco copiava dado
 * para não usar, e o único campo com conteúdo — o nome — era justamente o que estava errado.
 * A função agora vem do título do profissional no cadastro.
 * Ver docs/ANALISE-REFERENCIAS-DINAMICAS-NAS-PAGINAS.md §5.2 e §7.
 *
 * Não sobra decisão de página neste bloco — por isso ele não tem controle nenhum, só a explicação.
 *
 * Props:
 *   - value: {} (nada é gravado)
 *   - onChange: (patch) => void
 *   - context: { availableProfessionals }
 */
const TeamBlockEditor = ({ context = {} }) => {
  const { availableProfessionals = [] } = context;
  const ativos = availableProfessionals.filter((p) => p?.isActive !== false).length;

  return (
    <DescribedField
      label="Equipe"
      description="Todos os profissionais do seu cadastro aparecem nesta página automaticamente, com o nome, a função e a foto atuais. Para mudar o que aparece, edite o cadastro de Profissionais."
      helperLink={{ entity: 'professional' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {ativos === 0 ? (
          <Alert severity="info">
            Nenhum profissional cadastrado. Cadastre sua equipe para que apareça nesta página.
          </Alert>
        ) : (
          <Typography variant="caption" color="text.secondary">
            {ativos} profissional{ativos !== 1 ? 'is' : ''} será
            {ativos !== 1 ? 'ão' : ''} exibido{ativos !== 1 ? 's' : ''} nesta página.
          </Typography>
        )}
      </Box>
    </DescribedField>
  );
};

TeamBlockEditor.propTypes = {
  onChange: PropTypes.func,
  context: PropTypes.object,
};

export default TeamBlockEditor;
